var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-pdf-app',{staticStyle:{"height":"100vh"},attrs:{"theme":"light","download":false,"pdf":_vm.src}})
}
var staticRenderFns = []

export { render, staticRenderFns }